var env = process.env.NODE_ENV || 'development'
var awsexportconfig = {
    development: require('./aws-exports.js'),
    production: require('./aws-exports-prd.js'),
    staging: require('./aws-exports-prd.js')
}
module.exports = awsexportconfig[env]